<template>
  <div/>
</template>

<script setup lang="ts">
import { watch } from 'vue';
import { useStore } from 'vuex';
import { latestMessage, type WebSocketMessageWithFields, type WebSocketMessageEmpty } from '@/plugins/ws';

import {RootState} from "@/store";

const store = useStore<RootState>();

defineOptions({
  name: 'dataPriceCurrencies',
});

// Базовый тип для сообщений с индексом валюты
type PriceCurrencyWithIndex = {
  indexCurrency: number;
};

// Типы для WebSocket сообщений компонента priceCurrencies
type PriceCurrenciesListMessage = WebSocketMessageWithFields<'store-exchange-info' | 'store-info' | 'store-sync', {
  priceCurrencies: unknown[];
}>;
type PriceCurrencyCreateMessage = WebSocketMessageWithFields<'store-price-currency-create', PriceCurrencyWithIndex & {
  code: string;
}>;

// Объединенный тип для всех сообщений
type PriceCurrenciesWebSocketMessage = 
  | PriceCurrenciesListMessage 
  | PriceCurrencyCreateMessage;

// WebSocket message handler
const handleWebSocketMessage = (data: PriceCurrenciesWebSocketMessage): void => {
  if (!data?.signal) return;

  switch (data.signal) {
    case 'store-exchange-info':
    case 'store-info':
    case 'store-sync':
      store.dispatch('priceCurrencies/wsSetPriceCurrencies', {
        priceCurrencies: data.priceCurrencies,
      });
      break;

    case 'store-price-currency-create':
      store.dispatch('priceCurrencies/wsPriceCurrencyCreate', {
        indexCurrency: data.indexCurrency,
        code: data.code,
      });
      break;
  }
};

watch(latestMessage, handleWebSocketMessage);
</script>
